import { c as _c } from "react/compiler-runtime";
import { ProjectLaunchTarget } from "@custom-types/sdb-company-types";
import { Radio, RadioGroup } from "@flat-ui";
import { useMediaQueryList } from "@hooks/use-media-query";
import { Grid } from "@mui-wrapper";
import { companyCommunicationSettingsSelector, defaultProjectLaunchTargetSelector, fetchingSdbCompanyFlagsSelector } from "@store/sdb-company/sdb-company-selector";
import { updateCompanyCommunicationSettings } from "@store/sdb-company/sdb-company-slice-thunk";
import { useAppDispatch, useAppSelector } from "@store/store-helper";
import { CommonStyles } from "@styles/common-styles";
import { WorkspaceEvents } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";

/** Indent of a radio button from the divider of its column, in MUI spacing units (20px) */
const RADIO_INDENT = 2.5;

/** The available default platform items */
const DEFAULT_PLATFORM_ITEMS = {
  [ProjectLaunchTarget.sphereViewer]: {
    value: ProjectLaunchTarget.sphereViewer,
    label: "Sphere XG"
  },
  [ProjectLaunchTarget.webEditor]: {
    value: ProjectLaunchTarget.webEditor,
    label: "HoloBuilder"
  }
};

/** Renders the company setting that allows EAs to select the default platform to open projects */
export function DefaultPlatformSelector() {
  const $ = _c(13);
  const {
    isScreenSmOrSmaller
  } = useMediaQueryList();
  const dispatch = useAppDispatch();
  const {
    trackEvent
  } = useTrackEvent();
  const projectLaunchSettings = useAppSelector(defaultProjectLaunchTargetSelector);
  const {
    isUpdatingCompanyCommunicationSettings
  } = useAppSelector(fetchingSdbCompanyFlagsSelector);
  const communicationSettings = useAppSelector(companyCommunicationSettingsSelector);
  let t0;
  if ($[0] !== dispatch || $[1] !== trackEvent) {
    t0 = function handlePlatformChange(event) {
      const platform = event.target.value;
      trackEvent({
        name: WorkspaceEvents.updateSettings,
        props: {
          defaultPlatform: DEFAULT_PLATFORM_ITEMS[platform].label
        }
      });
      dispatch(updateCompanyCommunicationSettings({
        payload: {
          sphereViewerIsDefault: platform === ProjectLaunchTarget.sphereViewer
        }
      }));
    };
    $[0] = dispatch;
    $[1] = trackEvent;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const handlePlatformChange = t0;
  const t1 = projectLaunchSettings.defaultOpenProjectTarget;
  let t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      display: "flex",
      flexDirection: "row",
      width: "100%",
      height: "100%"
    };
    t3 = Object.values(DEFAULT_PLATFORM_ITEMS);
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] !== communicationSettings || $[6] !== isScreenSmOrSmaller || $[7] !== isUpdatingCompanyCommunicationSettings) {
    t4 = t3.map((item, index) => <Grid key={item.value} sx={{
      width: isScreenSmOrSmaller ? "100%" : "50%",
      borderLeft: index === 0 || isScreenSmOrSmaller ? "none" : CommonStyles.Borders.divider,
      alignItems: "center",
      alignContent: "center",
      pl: isScreenSmOrSmaller ? 0 : RADIO_INDENT
    }}><Radio value={item.value} label={item.label} disabled={isUpdatingCompanyCommunicationSettings || !communicationSettings} /></Grid>);
    $[5] = communicationSettings;
    $[6] = isScreenSmOrSmaller;
    $[7] = isUpdatingCompanyCommunicationSettings;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== handlePlatformChange || $[10] !== projectLaunchSettings.defaultOpenProjectTarget || $[11] !== t4) {
    t5 = <RadioGroup value={t1} onChange={handlePlatformChange} radioGroupSx={t2}>{t4}</RadioGroup>;
    $[9] = handlePlatformChange;
    $[10] = projectLaunchSettings.defaultOpenProjectTarget;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}